export default "__VITE_ASSET__266208f2__"